import axios from 'axios';
import {
  PROFILE_ENDPOINT,
  PROSPECT_ENDPOINT,
  SALESREP_ENDPOINT,
  UPDATE_BILLING_PREFERENCE_ENDPOINT,
  UPDATE_EMAIL_ENDPOINT,
  UPDATE_MOBILE_PHONE_ENDPOINT,
  UPDATE_PRIMARY_PHONE_ENDPOINT,
  VERIFY_MOBILE_PHONE_CODE_ENDPOINT,
  VERIFY_EMAIL_CODE_ENDPOINT,
} from '../constants/endpoint';
import { getRefreshToken } from '../providers/authTokenProvider';

export const GetUser = async () =>
  axios.get(`${PROFILE_ENDPOINT}`, {
    headers: {
      RefreshToken: getRefreshToken(),
    },
  });

export const UpdatePrimaryPhone = async primaryPhone => axios.patch(UPDATE_PRIMARY_PHONE_ENDPOINT, { primaryPhone });

export const UpdateMobilePhone = async mobilePhone => axios.post(UPDATE_MOBILE_PHONE_ENDPOINT, { phoneNumber: mobilePhone });

export const UpdateEmail = async (email, firstName) => axios.post(UPDATE_EMAIL_ENDPOINT, { email, firstName });

export const VerifyMobilePhoneCode = async code => axios.post(VERIFY_MOBILE_PHONE_CODE_ENDPOINT, { verificationCode: code });

export const VerifyEmailCode = async code => axios.post(VERIFY_EMAIL_CODE_ENDPOINT, { verificationCode: code });

export const GetProspect = async prospectId => axios.get(`${PROSPECT_ENDPOINT}/${prospectId}`);

export const GetSalesRep = async prospectId => axios.get(`${SALESREP_ENDPOINT}/${prospectId}`);

// Disabling due to line length
// eslint-disable-next-line
export const UpdateBillingPreference = async (billingNotificationPreference, contractId) => {
  return axios.patch(UPDATE_BILLING_PREFERENCE_ENDPOINT, { billingNotificationPreference, contractId });
};
